import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Resolve relative upload URLs to absolute
export const resolveUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  if (url.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};

// Module-level cache so we hit the API once per section per page load
const cache = new Map();
const inflight = new Map();

const fetchOnce = (key, url) => {
  if (cache.has(key)) return Promise.resolve(cache.get(key));
  if (inflight.has(key)) return inflight.get(key);
  const p = axios.get(url).then((r) => {
    cache.set(key, r.data);
    inflight.delete(key);
    return r.data;
  }).catch((e) => {
    inflight.delete(key);
    throw e;
  });
  inflight.set(key, p);
  return p;
};

// Generic hook: fetch a CMS section by key with hardcoded fallback while loading or on error.
export const useSection = (key, fallback = {}) => {
  const [data, setData] = useState(fallback);

  useEffect(() => {
    let alive = true;
    fetchOnce(`section:${key}`, `${API}/cms/sections/${key}`)
      .then((doc) => {
        if (!alive) return;
        setData({ ...fallback, ...(doc?.data || {}) });
      })
      .catch(() => {});
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return data;
};

export const useSettings = (fallback = {}) => {
  const [data, setData] = useState(fallback);
  useEffect(() => {
    let alive = true;
    fetchOnce("settings", `${API}/cms/settings`)
      .then((doc) => { if (alive) setData({ ...fallback, ...(doc?.data || {}) }); })
      .catch(() => {});
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return data;
};

export const usePrograms = (fallback = []) => {
  const [data, setData] = useState(fallback);
  useEffect(() => {
    let alive = true;
    fetchOnce("programs", `${API}/cms/programs`)
      .then((rows) => { if (alive && Array.isArray(rows) && rows.length) setData(rows); })
      .catch(() => {});
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return data;
};
